module.exports = __webpack_public_path__ + "static/media/favicon.f7477c4a.png";